const notifications = (state = 0, action) => {
  switch (action.type) {
    case 'SET':
      return action.unread;
    // The pill must not keep showing the count of the user who left.
    case 'LOGOUT':
      return 0;
    default:
      return state;
  }
};

export default notifications;
